import { render, staticRenderFns } from "./ModuleLogHistoryTable.vue?vue&type=template&id=2a41719c&scoped=true"
import script from "./ModuleLogHistoryTable.vue?vue&type=script&lang=js"
export * from "./ModuleLogHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ModuleLogHistoryTable.vue?vue&type=style&index=0&id=2a41719c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41719c",
  null
  
)

export default component.exports